import { getAppInfo, getDeviceInfo } from "@src/appV2/lib";
import { setReferralRate } from "@store/session/actions";
import { isEmpty } from "lodash";
import { FC, Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";

import { updateAgentVersion } from "./api";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
const WorkerAppVersion: FC<{}> = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const updateVersionInfo = async () => {
      dispatch(setReferralRate());
      const { version, build, otaBuildId } = await getAppInfo();
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line @typescript-eslint/no-wrapper-object-types
      if (isEmpty<String>(version) || isEmpty<String>(build)) {
        return;
      }
      const { platform } = await getDeviceInfo();

      await updateAgentVersion({
        platform,
        version: version,
        build: Number(build),
        otaBuildId,
      });
    };

    updateVersionInfo();
  }, [dispatch]);

  return <Fragment />;
};

export { WorkerAppVersion };
